/** Native HTML5 drag payload for mail rows → sidebar virtual folders. */
export const MAIL_DRAG_TYPE = "application/x-mysmall-message";

export interface DraggedMessage {
  accountId: number;
  /** RAW provider id (combined "acc:raw" prefix stripped). */
  messageId: string;
}

/** One drag may carry a whole multi-selection. */
export interface MessageDragPayload {
  messages: DraggedMessage[];
}

/** viewAccountId 0 = combined view (ids are "acc:raw"); otherwise raw ids. */
export function splitCombinedId(messageId: string, viewAccountId: number): DraggedMessage {
  const sep = messageId.indexOf(":");
  return viewAccountId === 0 && sep > 0
    ? { accountId: Number(messageId.slice(0, sep)), messageId: messageId.slice(sep + 1) }
    : { accountId: viewAccountId, messageId };
}

export function setMessageDragData(
  e: React.DragEvent,
  messageIds: string[],
  viewAccountId: number,
): void {
  const payload: MessageDragPayload = {
    messages: messageIds.map((id) => splitCombinedId(id, viewAccountId)),
  };
  e.dataTransfer.setData(MAIL_DRAG_TYPE, JSON.stringify(payload));
  e.dataTransfer.effectAllowed = "move";
}

export function parseMessageDrop(e: React.DragEvent): MessageDragPayload | null {
  try {
    const raw = e.dataTransfer.getData(MAIL_DRAG_TYPE);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as MessageDragPayload;
    const messages = (parsed.messages ?? []).filter((m) => m.accountId > 0 && m.messageId);
    return messages.length ? { messages } : null;
  } catch {
    return null;
  }
}
